import React, { FC } from 'react'
import styles from 'styles/components/calendar.module.scss'
import getDate from 'date-fns/getDate'
import isSameDay from 'date-fns/isSameDay'
import { HolidayCalendarCell } from 'components/Calendar'

type Props = {
  activeDates: Date[]
  currentMonth: Date
  row: Date[]
  selectDate: (date: Date) => void
}

const HolidayCalendarRow: FC<Props> = (props) => {
  const { activeDates, currentMonth, row, selectDate } = props

  return (
    <tr className={styles.table__row}>
      {row.map((date) => {
        const isActive = activeDates.some((activeDate) => isSameDay(activeDate, date))

        return (
          <HolidayCalendarCell
            currentMonth={currentMonth}
            key={getDate(date)}
            date={date}
            isActive={isActive}
            selectDate={selectDate}
          />
        )
      })}
    </tr>
  )
}

export default HolidayCalendarRow
